import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'

class ItemEditView extends Component {

  render() {
    document.body.className = window.location.pathname.replace(/\//g," ");

    const item_id = this.props.match.params.id;

    if (this.props.item_ids.indexOf(item_id) === -1){
      return (<Redirect to="/snap-photo" />)
    }else{
      if (this.props.current_user.get("syncing_item_props") === true){
        return (<Redirect to={`/item/${item_id}`} />)
      }else{
        const item = this.props.items_by_id.get(item_id)
        return (
          <div>
           <div className="container topbar bk-dark">
              <div className="back"><Link to={`/item/${item.get("id")}`}>« Back</Link></div>
              <div className="title">{item.get("name")}</div>
            </div>
            <form onSubmit={this.props.handleSubmit}>
            <div className="padding-10x">
              <p className="p-relative">
                <label className="form-label">Title</label> <Field component="input" type="text" name="name" placeholder='Title' />
                <div className="input-clear" onClick={this.props.handleClearNameClick}>&times;</div>
              </p>

              <p><label className="form-label">Description</label> <Field component="textarea" name="description" placeholder='Add Item Description' /></p>

              <p><label className="form-label">Internal Notes</label> <Field component="textarea" name="internal_notes" placeholder='Add Internal Notes' /></p>

              <Field component="hidden" name="item_id" defaultValue={item_id} />

              <Field component="hidden" name="venue_permalink" defaultValue={item.get("venue_permalink")} />
              <button>Edit</button>
              </div>
            </form>
          </div>
        )
      }
    }
  }
}

// WelcomeView.propTypes = {
//   current_user_id: PropTypes.number
// };

export default reduxForm({form: "snap-photo", enableReinitialize: true})(ItemEditView);




// WEBPACK FOOTER //
// ./src/snapit_app/components/ItemEditView.js